const getters = {
  getTabs({ nav }) {
    return nav;
  },
  getCanManagePatient({ canManagePatient }) {
    return canManagePatient;
  }
}

export default getters;